// Mutual-close for PDP accordions.
// When one .product-info__accordion opens, close all others in the same .accordion-group.
// Uses the AnimatedDetails setter (el.open = false) so _open stays in sync and
// the close animation runs — same pattern as Prestige's built-in theme.js.
document.addEventListener('click', function (e) {
  const summary = e.target.closest('summary');
  if (!summary) return;

  const opened = summary.closest('details[is="accordion-disclosure"]');
  if (!opened || !opened.open) return;

  const group = opened.closest('.accordion-group');
  if (!group) return;

  group.querySelectorAll('details[is="accordion-disclosure"]').forEach(function (el) {
    if (el !== opened && el.open) {
      el.open = false;
    }
  });
});



// ── Progress segments ─────────────────────────────────────────────────────────
// Highlights the active segment as the media carousel snaps between slides.
// Uses capture phase to catch scroll on media-carousel (doesn't bubble).
document.addEventListener('scroll', function (e) {
  var carousel = e.target;
  if (!carousel || carousel.tagName !== 'MEDIA-CAROUSEL') return;
  var gallery = carousel.closest('product-gallery');
  if (!gallery) return;
  var segments = gallery.querySelectorAll('.product-gallery__progress-segment');
  if (!segments.length) return;
  var index = Math.round(carousel.scrollLeft / carousel.clientWidth);
  segments.forEach(function (seg, i) {
    seg.classList.toggle('is-active', i === index);
  });
}, true);
